import { createRoot } from "react-dom/client"

// normalize CSS across browsers
import "./src/normalize.scss"
// custom CSS styles
import "./src/style.scss"

export function replaceHydrateFunction() {
  return (element, container) => {
    const root = createRoot(container)
    root.render(element)
  }
}
